/* Hauser MX — página de Contacto (Fase 12).
 *
 *   1. Estado en vivo   → recalcula el horario con la hora real de Morelos.
 *   2. Lienzo de señal  → ondas concéntricas detrás del hero.
 *   3. Tarjeta de vidrio→ inclinación 3D y brillo que sigue al puntero.
 *   4. Rutas            → elegir motivo acorta el formulario y lo re-titula.
 *   5. Pasos            → el formulario nativo se responde en tres tramos.
 *   6. Riel             → elegir una propiedad del catálogo con arrastre.
 *   7. Recorrido        → adjuntar la lista que el visitante ya armó.
 *   8. WhatsApp         → la misma solicitud, por el otro canal.
 *   9. Confirmación     → qué sigue después de enviar.
 *
 * ── PRINCIPIO (el mismo de las fases 10 y 11) ──────────────────────────────
 * Nada de aquí es necesario para usar la página. El HTML llega completo y
 * funcional desde Liquid: los cuatro motivos en un desplegable, el formulario
 * entero enviable, el riel recorrible con el dedo y el mapa pintado. Este
 * archivo solo REORGANIZA lo que ya está.
 *
 * Consecuencia práctica: **nada se oculta desde el CSS**. Los campos los
 * esconde este código, y solo después de haberse hecho cargo de la navegación.
 * Si falla a mitad, lo peor que pasa es que se vea el formulario largo — el
 * estado que ya funcionaba antes de esta fase.
 */
(function () {
  'use strict';

  var H = window.Hauser;
  var doc = document;

  /* Campos que NUNCA se apagan, pase lo que pase con la configuración de una
     ruta: son los tres que Shopify necesita para poder contestar, y dos de
     ellos son `required`. Un `required` escondido deja el formulario imposible
     de enviar y sin decir por qué. */
  var IMPRESCINDIBLES = ['nombre', 'telefono', 'email'];

  /* Qué campo va en qué tramo. Se decide AQUÍ y no en el snippet del
     formulario, que lo comparte Vender y no sabe de pasos. */
  var PASOS = [
    { campos: ['motivo', 'propiedad'], titulo: 'Qué necesitas' },
    { campos: ['cita', 'horario', 'mensaje'], titulo: 'Cuándo te acomoda' },
    { campos: ['nombre', 'telefono', 'email'], titulo: 'Cómo te contactamos' }
  ];

  /* Estado compartido entre módulos. Lo lee el compositor de WhatsApp. */
  var estado = {
    ruta: '',
    waLinea: '',
    propiedad: '',
    propiedadUrl: ''
  };

  function texto(el) {
    return el ? String(el.value || '').trim() : '';
  }

  function raizAbsoluta(camino) {
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return raiz + camino;
  }

  /* ── 1. Estado en vivo ────────────────────────────────────────────── */

  /* Liquid ya resolvió si estamos en horario, pero una página puede servirse
     desde la caché de Shopify horas después de haberse generado. Aquí se
     recalcula con la hora real, forzando la zona horaria de Morelos: si el
     visitante está en Madrid, lo que importa sigue siendo si la oficina está
     abierta, no si él está despierto. */
  function estadoEnVivo() {
    var caja = doc.querySelector('[data-chero-estado]');
    if (!caja) return;

    var modo = caja.getAttribute('data-modo');
    if (!modo || modo === 'off') return;

    var partes;
    try {
      partes = new Intl.DateTimeFormat('es-MX', {
        timeZone: 'America/Mexico_City',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).formatToParts(new Date());
    } catch (e) {
      return; /* sin Intl fiable, manda lo que dijo Liquid */
    }

    var hora = 0;
    var minuto = 0;
    var dia = null;
    partes.forEach(function (p) {
      if (p.type === 'hour') hora = parseInt(p.value, 10);
      if (p.type === 'minute') minuto = parseInt(p.value, 10);
      if (p.type === 'weekday') dia = p.value.toLowerCase();
    });

    /* `weekday: 'short'` en es-MX da "dom", "lun"… El índice 0 es domingo,
       igual que el %w de Liquid, para que las dos ramas cuenten igual. */
    var dias = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    var idx = -1;
    for (var i = 0; i < dias.length; i++) {
      if (dia && dia.indexOf(dias[i]) === 0) { idx = i; break; }
    }
    if (idx < 0) return;

    var diaOk = modo === 'ld' || (modo === 'lv' && idx > 0 && idx < 6) || (modo === 'ls' && idx > 0);

    function aMinutos(txt) {
      var m = String(txt || '').split(':');
      return (parseInt(m[0], 10) || 0) * 60 + (parseInt(m[1], 10) || 0);
    }
    var ahora = hora * 60 + minuto;
    var abierto = diaOk &&
      ahora >= aMinutos(caja.getAttribute('data-inicio')) &&
      ahora < aMinutos(caja.getAttribute('data-fin'));

    var punto = caja.querySelector('.hauser-chero__pulso');
    var txt = caja.querySelector('[data-chero-estado-txt]');
    if (punto) punto.setAttribute('data-encendido', abierto ? 'true' : 'false');
    if (txt) {
      txt.textContent = abierto
        ? caja.getAttribute('data-abierto-txt')
        : caja.getAttribute('data-cerrado-txt');
    }
  }

  /* ── 2. Lienzo de señal ───────────────────────────────────────────── */

  /* Ondas que salen del punto donde están los canales. La metáfora es
     literal —una señal que se emite— y por eso está en Contacto y en ninguna
     otra página. Canvas 2D y no WebGL: son cinco arcos, no vale un contexto
     GL ni los 11 KB del motor de shaders. */
  function lienzo() {
    if (!H || H.tier !== 'full' || H.reduced) return;

    var c = doc.querySelector('[data-chero-lienzo]');
    if (!c || !c.getContext) return;
    var ctx = c.getContext('2d');
    if (!ctx) return;

    var seccion = c.closest('[data-hauser-chero]') || c.parentNode;
    var ancho = 0;
    var alto = 0;

    function medir() {
      var r = c.getBoundingClientRect();
      var dpr = H.dpr;
      ancho = Math.max(1, Math.round(r.width));
      alto = Math.max(1, Math.round(r.height));
      c.width = Math.round(ancho * dpr);
      c.height = Math.round(alto * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    medir();

    if (window.ResizeObserver) new ResizeObserver(medir).observe(c);
    else window.addEventListener('resize', medir, { passive: true });

    /* Fuera de pantalla no se dibuja: el hero queda arriba del todo y el
       visitante pasa la mayor parte del tiempo abajo, leyendo. */
    var visible = true;
    H.enVista(seccion, function (dentro) { visible = dentro; }, { once: false, rootMargin: '0px' });

    var tinta = (getComputedStyle(doc.documentElement).getPropertyValue('--primario') || '').trim();
    if (!/^(#|rgb|hsl)/.test(tinta)) tinta = '#2F5D46';

    var ONDAS = 5;
    var PERIODO = 5200;

    H.porCuadro(function (t) {
      if (!visible || !ancho) return;
      ctx.clearRect(0, 0, ancho, alto);

      /* El origen se desplaza un poco con el puntero: lo justo para que se
         note que la página responde, no tanto como para marear. */
      var ox = ancho * (H.mobile ? 0.2 : 0.12) + H.puntero.scx * ancho * 0.035;
      var oy = alto * 0.74 + H.puntero.scy * alto * 0.03;
      var maxR = Math.sqrt(
        Math.pow(Math.max(ox, ancho - ox), 2) + Math.pow(Math.max(oy, alto - oy), 2)
      );

      ctx.lineWidth = 1;
      ctx.strokeStyle = tinta;
      for (var i = 0; i < ONDAS; i++) {
        var f = ((t + (i * PERIODO) / ONDAS) % PERIODO) / PERIODO;
        ctx.globalAlpha = (1 - f) * 0.45;
        ctx.beginPath();
        ctx.arc(ox, oy, f * maxR, 0, Math.PI * 2);
        ctx.stroke();
      }
      ctx.globalAlpha = 1;
    });
  }

  /* ── 3. Tarjeta de vidrio ─────────────────────────────────────────── */

  function tarjeta() {
    if (!H || H.tier === 'flat' || H.reduced || H.mqCoarse.matches) return;

    var caja = doc.querySelector('[data-chero-tarjeta]');
    if (!caja) return;
    var vidrio = caja.querySelector('.hauser-chero__vidrio');
    if (!vidrio) return;

    caja.setAttribute('data-tilt', '');

    /* El rectángulo se cachea y se refresca cada 200 ms. Medirlo en cada
       cuadro fuerza un recálculo de layout 60 veces por segundo por un efecto
       decorativo, que es exactamente el tipo de coste que no se ve en el
       escritorio del que lo programa y sí en un teléfono de gama media. */
    var caja_r = caja.getBoundingClientRect();
    var desde = 0;
    var ix = 0;
    var iy = 0;

    H.porCuadro(function (t, dt) {
      /* Hasta que el visitante mueve el ratón, el puntero global vale 0.5/0.5
         (el centro de la pantalla). Como la tarjeta vive en la mitad derecha,
         ese centro YA produce ángulo: la tarjeta se veía torcida de entrada,
         como si estuviera mal maquetada. Se espera al primer movimiento. */
      if (!H.puntero.activo) return;
      if (t - desde > 200) { caja_r = caja.getBoundingClientRect(); desde = t; }
      if (!caja_r.width) return;

      var px = H.puntero.x * window.innerWidth;
      var py = H.puntero.y * window.innerHeight;
      var dx = (px - (caja_r.left + caja_r.width / 2)) / (caja_r.width / 2);
      var dy = (py - (caja_r.top + caja_r.height / 2)) / (caja_r.height / 2);
      dx = Math.max(-1.6, Math.min(1.6, dx));
      dy = Math.max(-1.6, Math.min(1.6, dy));

      var k = 1 - Math.exp(-9 * (dt / 1000));
      ix += (dx - ix) * k;
      iy += (dy - iy) * k;

      vidrio.style.transform = 'rotateX(' + (-iy * 3.2).toFixed(2) + 'deg) rotateY(' + (ix * 4.5).toFixed(2) + 'deg)';
      vidrio.style.setProperty('--brillo-x', (50 + ix * 30).toFixed(1) + '%');
      vidrio.style.setProperty('--brillo-y', (50 + iy * 30).toFixed(1) + '%');
    });
  }

  /* ── 4 a 9. La solicitud ──────────────────────────────────────────── */

  function solicitud() {
    var sec = doc.querySelector('[data-hauser-csol]');
    if (!sec) return;

    var form = sec.querySelector('form');
    var contenedor = sec.querySelector('.hauser-form__campos');
    var enviar = sec.querySelector('.hauser-form__enviar');

    /* Tras un envío correcto, Shopify repinta la sección con el mensaje de
       éxito y sin campos. Ahí no hay nada que trocear: toca dar las gracias. */
    if (!form || !contenedor || !enviar || !contenedor.querySelector('[data-campo]')) {
      gracias(sec);
      return;
    }

    var campos = {};
    Array.prototype.forEach.call(contenedor.querySelectorAll('[data-campo]'), function (el) {
      campos[el.getAttribute('data-campo')] = el;
    });

    var selector = sec.querySelector('[data-csol-selector]');
    var tituloForm = sec.querySelector('[data-csol-titulo]');
    var tituloOriginal = tituloForm ? tituloForm.textContent.trim() : '';
    var selectMotivo = campos.motivo ? campos.motivo.querySelector('select') : null;

    /* Campos encendidos por la ruta activa. De arranque, todos. */
    var activos = null;

    function encendido(clave) {
      if (IMPRESCINDIBLES.indexOf(clave) > -1) return true;
      if (!activos) return true;
      return activos.indexOf(clave) > -1;
    }

    /* ── Pasos ── */
    var tramos = [];
    var actual = 0;

    function reconstruirTramos() {
      tramos = PASOS.map(function (p) {
        return {
          titulo: p.titulo,
          nodos: p.campos.filter(encendido).map(function (c) { return campos[c]; }).filter(Boolean)
        };
      }).filter(function (p) { return p.nodos.length > 0; });
      if (actual > tramos.length - 1) actual = tramos.length - 1;
      if (actual < 0) actual = 0;
    }
    reconstruirTramos();
    if (tramos.length < 2) return;

    var avance = sec.querySelector('[data-avance]');
    var avActual = sec.querySelector('[data-avance-actual]');
    var avTotal = sec.querySelector('[data-avance-total]');
    var avBarra = sec.querySelector('[data-avance-barra]');
    if (avance) avance.hidden = false;

    var nav = doc.createElement('div');
    nav.className = 'hauser-csol__nav';

    var atras = doc.createElement('button');
    atras.type = 'button';
    atras.className = 'hauser-csol__atras';
    atras.textContent = '← Atrás';

    var siguiente = doc.createElement('button');
    siguiente.type = 'button';
    siguiente.className = 'hauser-boton-primario hauser-csol__siguiente';
    siguiente.textContent = 'Siguiente';

    var wa = doc.createElement('button');
    wa.type = 'button';
    wa.className = 'hauser-csol__wa';
    wa.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
      '<path d="M12 2a10 10 0 0 0-8.6 15L2 22l5.2-1.4A10 10 0 1 0 12 2Zm5.6 14.2c-.2.7-1.4 1.3-2 1.4-.5.1-1.2.1-1.9-.1a12 12 0 0 1-6.9-6c-.5-.9-.8-1.9-.8-2.7 0-1 .5-1.6.8-1.8.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 1.9c.1.2 0 .4-.1.6l-.4.5c-.1.1-.3.3-.1.6.2.4.8 1.3 1.7 2.1 1.1 1 2 1.3 2.3 1.4.2.1.4.1.6-.1l.7-.8c.2-.2.4-.2.6-.1l1.8.9c.2.1.4.2.4.3.1.2.1.6-.1 1.2Z"/></svg>' +
      '<span>Mandarlo por WhatsApp</span>';

    /* El botón nativo se mueve DENTRO de la navegación para que en el último
       tramo aparezca junto a la salida de WhatsApp, sin duplicar botones. */
    nav.appendChild(atras);
    nav.appendChild(siguiente);
    enviar.parentNode.insertBefore(nav, enviar);
    nav.appendChild(enviar);
    nav.appendChild(wa);

    /* Anuncio para lector de pantalla: sin esto, avanzar de paso es un cambio
       silencioso y quien no ve la barra no se entera de que pasó algo. */
    var anuncio = doc.createElement('p');
    anuncio.className = 'visually-hidden';
    anuncio.setAttribute('role', 'status');
    anuncio.setAttribute('aria-live', 'polite');
    nav.parentNode.insertBefore(anuncio, nav);

    function pintar(mover) {
      /* Primero la ruta: apaga lo que no aplica y DESHABILITA sus controles,
         para que un campo escondido no pueda bloquear la validación nativa ni
         viajar en el correo con un valor que nadie escribió. */
      Object.keys(campos).forEach(function (clave) {
        var on = encendido(clave);
        var nodo = campos[clave];
        if (!on) nodo.hidden = true;
        Array.prototype.forEach.call(nodo.querySelectorAll('input, select, textarea'), function (c) {
          c.disabled = !on;
        });
      });

      tramos.forEach(function (t, i) {
        t.nodos.forEach(function (n) { n.hidden = i !== actual; });
      });

      var ultimo = actual === tramos.length - 1;
      atras.hidden = actual === 0;
      siguiente.hidden = ultimo;
      enviar.hidden = !ultimo;
      wa.hidden = !ultimo;

      if (selector) {
        var visibleProp = encendido('propiedad') && campos.propiedad && !campos.propiedad.hidden;
        selector.hidden = !visibleProp;
      }

      if (avActual) avActual.textContent = String(actual + 1);
      if (avTotal) avTotal.textContent = String(tramos.length);
      if (avBarra) avBarra.style.width = (((actual + 1) / tramos.length) * 100).toFixed(0) + '%';

      if (mover) {
        anuncio.textContent = 'Paso ' + (actual + 1) + ' de ' + tramos.length + ': ' + tramos[actual].titulo;
        var primero = tramos[actual].nodos[0].querySelector('input, select, textarea');
        if (primero && primero.type !== 'radio' && !primero.disabled) {
          try { primero.focus({ preventScroll: true }); } catch (e) { primero.focus(); }
        }
      }
    }

    /* Valida solo el tramo visible, apoyándose en el `required` que los campos
       ya traen del snippet: no se duplica aquí ninguna regla. */
    function valido() {
      var ok = true;
      tramos[actual].nodos.forEach(function (n) {
        Array.prototype.forEach.call(n.querySelectorAll('input, select, textarea'), function (c) {
          if (c.disabled) return;
          if (!c.checkValidity()) {
            if (ok) c.reportValidity();
            ok = false;
          }
        });
      });
      return ok;
    }

    siguiente.addEventListener('click', function () {
      if (!valido()) return;
      if (actual < tramos.length - 1) { actual++; pintar(true); }
    });
    atras.addEventListener('click', function () {
      if (actual > 0) { actual--; pintar(true); }
    });

    /* Enter dentro de un campo avanza en vez de enviar a medio cuestionario. */
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      if (e.target && e.target.tagName === 'TEXTAREA') return;
      if (actual < tramos.length - 1) {
        e.preventDefault();
        siguiente.click();
      }
    });

    /* ── Rutas ── */
    rutas(sec, campos, selectMotivo, tituloForm, tituloOriginal, function (lista) {
      activos = lista;
      actual = 0;
      reconstruirTramos();
      pintar(false);
    });

    /* ── Riel de propiedades ── */
    riel(sec, campos);

    /* ── Puente con el recorrido ── */
    recorrido(sec, campos);

    /* ── WhatsApp ── */
    wa.addEventListener('click', function () {
      if (!valido()) return;

      var cfg = window.HauserRecorrido || {};
      var numero = String(cfg.numero || '').replace(/\D/g, '');
      if (!numero) return; /* sin número configurado no se abre nada roto */

      function valor(clave) {
        var n = campos[clave];
        if (!n || !encendido(clave)) return '';
        var marcado = n.querySelector('input[type="radio"]:checked');
        if (marcado) return marcado.value;
        return texto(n.querySelector('input, select, textarea'));
      }

      var lineas = [estado.waLinea || 'Hola, quiero información de HAUSER MX.'];
      var pares = [
        ['Motivo', estado.ruta || valor('motivo')],
        ['Propiedad', estado.propiedad || valor('propiedad')],
        ['Cuándo me acomoda', valor('cita')],
        ['Horario', valor('horario')],
        ['Nombre', valor('nombre')],
        ['Teléfono', valor('telefono')]
      ];
      pares.forEach(function (p) { if (p[1]) lineas.push(p[0] + ': ' + p[1]); });
      if (estado.propiedadUrl) lineas.push(location.origin + estado.propiedadUrl);

      var extra = valor('mensaje');
      if (extra) lineas.push('', extra);

      window.open('https://wa.me/' + numero + '?text=' + encodeURIComponent(lineas.join('\n')), '_blank', 'noopener');
    });

    pintar(false);
  }

  /* ── 4. Enrutador de intención ────────────────────────────────────── */

  function rutas(sec, campos, selectMotivo, tituloForm, tituloOriginal, alElegir) {
    var zona = doc.querySelector('[data-hauser-crutas]');
    if (!zona) return;

    var tarjetas = Array.prototype.slice.call(zona.querySelectorAll('.hauser-cruta'));
    if (!tarjetas.length) return;

    /* Reconciliación: si el desplegable de Motivo no trae alguna de las rutas
       (porque alguien renombró una y no la otra), se añade. Así el correo
       nunca llega con el motivo vacío por una divergencia de textos. */
    if (selectMotivo) {
      tarjetas.forEach(function (t) {
        var v = t.getAttribute('data-ruta');
        if (!v) return;
        var existe = Array.prototype.some.call(selectMotivo.options, function (o) { return o.value === v; });
        if (!existe) {
          var op = doc.createElement('option');
          op.value = v;
          op.textContent = v;
          selectMotivo.appendChild(op);
        }
      });
    }

    /* Foco de luz. Un solo listener delegado en la rejilla, y solo con puntero
       fino: en táctil no hay hover que seguir. */
    if (H && !H.mqCoarse.matches && H.tier !== 'flat') {
      zona.addEventListener('pointermove', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('.hauser-cruta') : null;
        if (!t) return;
        var r = t.getBoundingClientRect();
        t.style.setProperty('--mx', (((e.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
        t.style.setProperty('--my', (((e.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
        t.style.setProperty('--luz', '1');
      });
      zona.addEventListener('pointerleave', function () {
        tarjetas.forEach(function (t) { t.style.setProperty('--luz', '0'); });
      });
      zona.addEventListener('pointerout', function (e) {
        var t = e.target && e.target.closest ? e.target.closest('.hauser-cruta') : null;
        if (t && !t.contains(e.relatedTarget)) t.style.setProperty('--luz', '0');
      });
    }

    function elegir(tarjeta, mover) {
      var etiqueta = tarjeta.getAttribute('data-ruta') || '';
      var lista = (tarjeta.getAttribute('data-campos') || '')
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean);

      tarjetas.forEach(function (t) {
        if (t === tarjeta) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });

      estado.ruta = etiqueta;
      estado.waLinea = tarjeta.getAttribute('data-wa') || '';

      if (selectMotivo) {
        selectMotivo.value = etiqueta;
        /* Si el valor no existiera en el desplegable, el navegador lo deja
           vacío en silencio; se vuelve al primero para no mandar un campo en
           blanco creyendo que se mandó lleno. */
        if (selectMotivo.value !== etiqueta) selectMotivo.selectedIndex = 0;
      }

      var titulo = tarjeta.getAttribute('data-titulo-form');
      if (tituloForm) tituloForm.textContent = titulo || tituloOriginal;

      alElegir(lista.length ? lista : null);

      if (mover) {
        try { sec.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { sec.scrollIntoView(); }
      }
    }

    tarjetas.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        elegir(t, true);
      });
    });
  }

  /* ── 6. Riel de propiedades ───────────────────────────────────────── */

  function riel(sec, campos) {
    var caja = sec.querySelector('[data-csol-riel]');
    var pista = sec.querySelector('[data-csol-pista]');
    if (!caja || !pista) return;

    var botones = Array.prototype.slice.call(pista.querySelectorAll('[data-csol-prop]'));
    if (!botones.length) return;

    var entrada = campos.propiedad ? campos.propiedad.querySelector('input') : null;

    botones.forEach(function (b) {
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () {
        var yaEstaba = b.getAttribute('aria-pressed') === 'true';
        botones.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });

        if (yaEstaba) {
          estado.propiedad = '';
          estado.propiedadUrl = '';
          if (entrada) entrada.value = '';
          return;
        }

        b.setAttribute('aria-pressed', 'true');
        estado.propiedad = b.getAttribute('data-titulo') || '';
        estado.propiedadUrl = b.getAttribute('data-url') || '';
        if (entrada) entrada.value = estado.propiedad;
      });
    });

    /* Arrastre con inercia solo con puntero fino. En táctil el scroll nativo
       del riel ya es mejor que cualquier cosa que se pueda programar, y
       robarle el gesto al dedo empeora la página. */
    if (!H || H.mqCoarse.matches || H.tier === 'flat' || !window.gsap || !window.Draggable) return;

    caja.setAttribute('data-arrastrable', '');

    function limites() {
      return { minX: Math.min(0, caja.clientWidth - pista.scrollWidth), maxX: 0 };
    }

    var arrastre = window.Draggable.create(pista, {
      type: 'x',
      bounds: limites(),
      inertia: !!window.InertiaPlugin,
      edgeResistance: 0.9,
      dragClickables: true,
      cursor: 'grab',
      activeCursor: 'grabbing'
    })[0];

    window.addEventListener('resize', function () {
      if (!arrastre) return;
      arrastre.applyBounds(limites());
    }, { passive: true });
  }

  /* ── 7. Puente con «Tu recorrido» ─────────────────────────────────── */

  function recorrido(sec, campos) {
    var caja = sec.querySelector('[data-csol-recorrido]');
    if (!caja) return;

    var boton = caja.querySelector('[data-csol-recorrido-adjuntar]');
    var numero = caja.querySelector('[data-csol-recorrido-n]');
    var palabra = caja.querySelector('[data-csol-recorrido-palabra]');
    var mensaje = campos.mensaje ? campos.mensaje.querySelector('textarea') : null;
    var lista = [];

    function pintar(items) {
      lista = items || [];
      caja.hidden = lista.length === 0;
      if (numero) numero.textContent = String(lista.length);
      if (palabra) palabra.textContent = lista.length === 1 ? 'propiedad' : 'propiedades';
    }

    /* Se vuelve a pedir el carrito al cargar: la página puede venir de la
       caché de Shopify con un conteo viejo, y ofrecer «tus 5 propiedades»
       cuando ya son 2 es peor que no ofrecer nada. */
    fetch(raizAbsoluta('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (carro) {
        if (!carro || !carro.items) return;
        pintar(carro.items.map(function (it) {
          /* La URL del carrito trae ?variant=…, que en un WhatsApp es ruido
             y hace la línea el doble de larga. Se manda la ficha, a secas. */
          return { titulo: it.product_title || it.title, url: String(it.url || '').split('?')[0] };
        }));
      })
      .catch(function () { /* se queda con lo que pintó Liquid */ });

    if (!boton) return;
    boton.addEventListener('click', function () {
      if (!mensaje || !lista.length) return;

      var texto_lista = lista.map(function (p) {
        return '· ' + p.titulo + (p.url ? ' (' + location.origin + p.url + ')' : '');
      }).join('\n');

      var previo = mensaje.value.trim();
      var encabezado = 'Me interesan estas propiedades de mi recorrido:';
      if (previo.indexOf(encabezado) > -1) return;

      mensaje.value = (previo ? previo + '\n\n' : '') + encabezado + '\n' + texto_lista;
      boton.textContent = 'Listo, ya van en tu mensaje';
      boton.setAttribute('data-listo', '');
      boton.disabled = true;
    });
  }

  /* ── 9. Confirmación ──────────────────────────────────────────────── */

  function gracias(sec) {
    var ok = sec.querySelector('.hauser-form__ok');
    var plantilla = sec.querySelector('[data-csol-gracias]');
    if (!ok || !plantilla || !plantilla.content) return;

    ok.parentNode.insertBefore(plantilla.content.cloneNode(true), ok.nextSibling);
    /* El foco va al mensaje, no al panel: lo primero que hay que oír es que
       sí se envió. El panel viene detrás en el orden del documento. */
    try { ok.focus({ preventScroll: true }); } catch (e) { /* tabindex ya está en el snippet */ }
  }

  /* ── arranque ─────────────────────────────────────────────────────── */

  function arrancar() {
    [estadoEnVivo, lienzo, tarjeta, solicitud].forEach(function (fn) {
      try {
        fn();
      } catch (e) {
        if (window.console) console.warn('[Hauser] Contacto, efecto con error:', e);
      }
    });
  }

  /* No depende del motor de movimiento: los canales y el formulario no son
     decoración, son la interfaz que convierte. Si `Hauser` no existe, esto
     tiene que funcionar igual. */
  if (H && typeof H.listo === 'function') H.listo(arrancar);
  else if (doc.readyState !== 'loading') arrancar();
  else doc.addEventListener('DOMContentLoaded', arrancar);
})();
